import { currency } from "../../../utils/number.utils";

export default function SearchedCarInfo({ data, children }) {
  return (
    <div className="border rounded p-3 mb-3">
      <ul className="list-unstyled mb-0">
        <li>
          <b>ID:</b> {data?.sku ?? ""}
        </li>
        <li>
          <b>Chassis:</b> {data?.fullChassis ?? ""}
        </li>
        <li>
          <b>Vehicle Name:</b> {data?.name ?? ""}
        </li>
        <li>
          <b>Year/Model:</b> {data?.year ?? ""}
        </li>
        <li>
          <b>Color:</b> {data?.color ?? ""}
        </li>
        <li>
          <b>Price:</b> <del>{currency(data?.asking_price)}</del> {currency(data?.discount_price)}
        </li>
      </ul>
      {children}
    </div>
  );
}
